import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloProfilExclusion, cleanAloProfilExclusion } from '@/models/alo/AloProfilExclusion'

export default {
  getAllProfilExclusion(): AxiosPromise<AlrContainer<Array<AloProfilExclusion>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/ProfilExclusion`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloProfilExclusion>>
      }]
    })
  },
  getProfilExclusion(id:number):AxiosPromise<AlrContainer<AloProfilExclusion>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/ProfilExclusion/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloProfilExclusion>
      }]
    })
  },
  saveProfilExclusion(profilExclusion:AloProfilExclusion):AxiosPromise<AlrContainer<AloProfilExclusion>> {
    cleanAloProfilExclusion(profilExclusion)
    if(profilExclusion.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/ProfilExclusion/${profilExclusion.id}`, 
        method: 'PUT',
        data: profilExclusion,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloProfilExclusion>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/ProfilExclusion`, 
        method: 'POST',
        data: profilExclusion,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloProfilExclusion>
        }]
      })    
    }
  },
  deleteProfilExclusion(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/ProfilExclusion/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloProfilExclusion>
      }]
    })
  }
}